// Switches between tab panels, e.g. the profile page's recent/top games.
// Expects a `[role="tablist"]` of `tab` variant button components, each with
// `aria-controls` pointing at its `[role="tabpanel"]`.

import { onElements } from './dom.js'

const initTablist = (tablist) => {
    if (tablist.dataset.tablistInitialized) return
    tablist.dataset.tablistInitialized = 'true'

    const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'))

    const select = (selectedTab) => {
        tabs.forEach((tab) => {
            const selected = tab === selectedTab
            tab.setAttribute('aria-selected', selected)
            tab.tabIndex = selected ? 0 : -1
            const panel = document.getElementById(
                tab.getAttribute('aria-controls')
            )
            if (panel) panel.hidden = !selected
        })
    }

    tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab))
        // Arrow keys move between tabs, per the WAI-ARIA tabs pattern
        tab.addEventListener('keydown', (event) => {
            const targets = {
                ArrowRight: (index + 1) % tabs.length,
                ArrowLeft: (index - 1 + tabs.length) % tabs.length,
                Home: 0,
                End: tabs.length - 1,
            }
            if (!(event.key in targets)) return
            event.preventDefault()
            const next = tabs[targets[event.key]]
            select(next)
            next.focus()
        })
    })

    select(
        tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') ??
            tabs[0]
    )
    tablist.hidden = false
}

onElements('[role="tablist"]', initTablist)
